import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Card1 from "../Images/NewsFeeds/SKACS Training/(1).jpg";
import Card3 from "../Images/NewsFeeds/SKACS Training/(2).jpg";
import Card4 from "../Images/NewsFeeds/SKACS Training/(3).jpg";
import Card5 from "../Images/NewsFeeds/SKACS Field/20260309_105114.jpg";
import Card6 from "../Images/NewsFeeds/SKACS Field/20260310_172945.jpg";
import Card7 from "../Images/NewsFeeds/SKACS Field/20260312_112857.jpg";

function SKACSTraining() {
  return (
    <div className="art-page">
      <SEO
        title="Training in Progress | Schools Kitchen and Cooking Study (SKACS) Project – Uganda"
        description="CIRCODU conducts intensive training for the SKACS study under Uganda's eCooking Pilot."
        keywords="SKACS, school kitchen cooking study, eCooking Uganda, MECS, MEMD, clean cooking schools, electric cooking Uganda, biomass transition, cooking energy use, fuel consumption, kitchen practices, clean cooking data, carbon credit initiatives, SKACS training, SKACS protocol, school cooking study Uganda, SKACS evidence, clean cooking research Uganda, SKACS field training, SKACS data collection, SKACS clean cooking, SKACS school kitchens, SKACS cooking behaviours, SKACS energy implications, SKACS fuel use, SKACS cooking solutions, SKACS clean cooking transition, SKACS school energy use, SKACS cooking practices, SKACS clean cooking data, SKACS carbon credit, SKACS clean cooking initiatives"
        url="/Training-in-Progress-Schools-Kitchen-and-Cooking-Study-SKACS-Project-Uganda"
        image={Card7}
        datePublished="2026-02-05"
      />

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Training in Progress | Schools Kitchen and Cooking Study (SKACS)
              Project – Uganda
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            <div className="art-date">
              <span className="art-date__dot" />
              February 5, 2026
            </div>

            <h1 className="art-title">
              Training in Progress | Schools Kitchen and Cooking Study (SKACS)
              Project – Uganda
            </h1>

            <div className="texty">
              <p>
                We are gearing up for field engagements as researchers undergo
                intensive training for the{" "}
                <strong>Schools Kitchen and Cooking Study (SKACS)</strong> in
                selected schools under the eCooking Pilot — implemented by the{" "}
                <strong>
                  Ministry of Energy and Mineral Development (MEMD)
                </strong>{" "}
                in collaboration with the{" "}
                <strong>
                  Centre for Integrated Research and Community Development
                  Uganda (CIRCODU)
                </strong>{" "}
                and the <strong>MECS Programme</strong>.
              </p>
              <img
                src={Card1}
                alt="CIRCODU Team Members during Training for the SKACS Project"
                className="art-img"
              />
              <h2 className="art-subheading">
                A Milestone for Clean Cooking in Schools
              </h2>
              <p>
                This milestone marks another meaningful step forward in
                realising the MECS Programme's <strong>#UKAID</strong> vision of
                introducing modern electric cooking solutions into institutions
                across Uganda. With growing interest in transitioning school
                kitchens away from biomass fuels, SKACS is specifically designed
                to generate much-needed evidence on energy use, fuel
                consumption, and kitchen practices in schools — an area where
                reliable data has historically been extremely limited.
              </p>
              <img
                src={Card3}
                alt="CIRCODU Team Members during Training for the SKACS Project"
                className="art-img"
              />
              <h2 className="art-subheading">What the Training Covers</h2>
              <p>
                The training equips researchers with the{" "}
                <strong>SKACS Protocol</strong> — a comprehensive methodology
                developed to ensure consistent and reliable data collection
                across all participating schools. Specifically, the protocol
                covers:
              </p>
              <ol>
                <li>School kitchen characteristics and cooking behaviours</li>
                <li>Fuel use at both kitchen-day and dish levels</li>
                <li>
                  Energy and cost implications of transitioning from biomass
                  fuels to clean cooking alternatives
                </li>
              </ol>
              <img
                src={Card7}
                alt="A CIRCODU Researcher durring a physical school visit doing a survey"
                className="art-img"
              />
              <img
                src={Card6}
                alt="The cooking pots at a certain school"
                className="art-img"
              />
              <img
                src={Card5}
                alt="Students at a school kitchen during a survey"
                className="art-img"
              />
              <h2 className="art-subheading">Why This Data Matters</h2>
              <p>
                By gathering this information systematically, SKACS aims to
                build a <strong>robust, evidence-based database</strong> that
                will directly support planning, guide investment decisions, and
                inform future clean cooking and carbon credit initiatives.
                Beyond numbers, the study will also serve as a platform for
                amplifying clean cooking messages to schools, teachers,
                students, and the wider community — creating ripple effects that
                extend far beyond the school gate.
              </p>
              <p>
                As our teams prepare to head to the field, we look forward to
                generating the evidence that will help drive cleaner, healthier,
                and more sustainable cooking solutions across Uganda's schools.
                Every data point collected brings us closer to a future where no
                child learns in a smoke-filled kitchen.
              </p>
            </div>
            <img
              src={Card4}
              alt="CIRCODU Team Members during Training for the SKACS Project"
              className="art-img"
            />
            <div className="art-cta">
              <p>
                Stay tuned on our online platforms for more updates on the SKACS
                project and our other ongoing initiatives. Contact us at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call <a href="tel:+256392004309">+256 (0) 392 004 309</a> /{" "}
                <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>

            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default SKACSTraining;
